import { useState, useEffect } from 'react';

import { useSortAndFilterResultsContext } from '../../../SortAndFilterResults/SortAndFilterResultsContext';
import { useTreatmentFilterStateContext } from '../../context/TreatmentFilterContext';
import { Statistic } from '../../../../../../modules/sortAndFilter/workers/sortAndFilter';

/**
 * Hook to cache statistics for a given filter type. If the last filter updated is the same as the current
 * filter key, then we don't need to update the statistics as we want to stop the statistic numbers in the UI
 * jumping around for options that are selected in the same filter category.
 */
const useCachedStatistics = (key: 'brand' | 'conditions' | 'activeIngredient' | 'drugClass' | 'price' | 'review' | 'treatmentForm') => {
    const { lastFilterUpdated } = useTreatmentFilterStateContext();
    const { statistics: currentStatistics, processing } = useSortAndFilterResultsContext();

    const [statistics, setStatistics] = useState<Statistic[]>(currentStatistics[key].statistics);

    useEffect(() => {
        // Processing is included as we want to wait for the most up to date statistics before displaying.
        if (lastFilterUpdated === key || processing) {
            return;
        }

        // Otherwise, update the statistics.
        setStatistics(currentStatistics[key].statistics);
    }, [lastFilterUpdated, currentStatistics, key, processing]);

    return statistics;
};

export default useCachedStatistics;
